import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { StandardActionModal } from 'src/common/components/standard-action-modal';
import { StyledModalIcon } from 'src/common/components/standard-action-modal/standard-action-modal.styles';
import { OptionsModalProps } from 'src/features/room/room.types';
import { StyledModalBodyText } from '../../commons';
const iconComponent = <StyledModalIcon data-icon="warning" icon={faWarning} />;
const modalBodyText = <StyledModalBodyText>
    This network is resetting. Please wait a few minutes whilst the network rebuilds (machine IPs will stay the same).
  </StyledModalBodyText>;
export const NetworkResetModal = ({
  open,
  onOpenChange
}: Omit<OptionsModalProps, 'roomCode'>) => <StandardActionModal modalTitleText="Network Reset" modalBodyText={modalBodyText} dismissButtonTitle="Close" showIcon iconComponent={iconComponent} open={open} onOpenChange={onOpenChange} showActionButton={false} data-sentry-element="StandardActionModal" data-sentry-component="NetworkResetModal" data-sentry-source-file="network-reset-modal.tsx" />;